module.exports = __webpack_public_path__ + "static/img/samajuri (18).344ad59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (18).jpg
// module id = ALzR
// module chunks = 0